export const fontSizePlugin = {
  isLeaf: true,
};
